// Export exam notes as markdown file
// Downloads a structured markdown document with all exam concepts

import type { ExamConcept } from '../types';

export function exportExamNotes(topicTitle: string, concepts: ExamConcept[]): void {
  const lines: string[] = [
    `# Eksamensforberedelse: ${topicTitle}`,
    '',
    '## Begreber',
    '',
  ];

  for (const concept of concepts) {
    const badge = concept.qualified ? '\u2713' : '\u26a0\ufe0f';
    lines.push(`### ${concept.term} ${badge}`);
    if (concept.description) {
      lines.push(concept.description);
    }
    lines.push('');
  }

  lines.push('---');
  lines.push(`Eksporteret fra Lyra \u00b7 ${new Date().toLocaleDateString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' })}`);

  const content = lines.join('\n');
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `eksamen-${topicTitle.toLowerCase().replace(/\s+/g, '-')}.md`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
